// pages/login/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Link } from 'gatsby-theme-material-ui';
import { BigTextLogo } from '../../components/Logo'
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Footer from '../../components/Footer'
import { Helmet } from "react-helmet"
import Divider from '@material-ui/core/Divider';
import Bar from '../../components/Bar'
import LoginForm from '../../apps/LoginForm'

const useStyles = makeStyles((theme) => 
  createStyles({
    divider: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3)
    },
    container: {
      flex: 1,
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      flexDirection: 'column',
      height: '100vh'
    },
    center: {
      flex: 1,
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'center',
      flexDirection: 'column',
    },
  })
)
export default function Login() {
  const classes = useStyles()
  return (
    <Fragment>
      <Bar/>
      <Container maxWidth="md" className={classes.container}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>AMRC | Login</title>
          <link rel="canonical" href="https://tryamrc.com/contact" />
        </Helmet>
        
        <Box my={9} className={classes.center}>
          <br/>
          <LoginForm/>
          {/* <Typography 
            variant="h6" 
            component="h1" 
            color="secondary"
            gutterBottom>
            <Link to="mailto:team@tryamrc.com">team@tryamrc.com</Link>
          </Typography>
          <Typography 
            variant="h6" 
            component="h1" 
            color="secondary"
            gutterBottom>
            <Link to="phone:+14242488310">(424) 248-8310</Link>
          </Typography> */}
          
        </Box>
        <Footer/>
      </Container>
    </Fragment>
  );
}
